import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="schema-extra-field-form"
// Validates required selects (wrapped by SlimSelect) before allowing form submission and drawer close.
export default class extends Controller {
  static targets = ["requiredSelect"]

  reset() {
    this.requiredSelectTargets.forEach((select) => {
      const ssMain = select.nextElementSibling
      if (ssMain && ssMain.classList.contains("ss-main")) {
        ssMain.classList.remove("ss-error")
        this.#clearError(ssMain)
      }
    })
  }

  submit(event) {
    if (!this.#validate()) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    this.dispatch("valid")
  }

  #validate() {
    let valid = true

    this.requiredSelectTargets.forEach((select) => {
      const ssMain = select.nextElementSibling
      if (!select.value || select.value === "") {
        valid = false
        if (ssMain && ssMain.classList.contains("ss-main")) {
          ssMain.classList.add("ss-error")
          this.#showError(ssMain, "This field is required")
        }
      } else {
        if (ssMain && ssMain.classList.contains("ss-main")) {
          ssMain.classList.remove("ss-error")
          this.#clearError(ssMain)
        }
      }
    })

    return valid
  }

  #showError(ssMain, message) {
    if (ssMain.nextElementSibling?.classList.contains("form-error")) return

    const errorDiv = document.createElement("div")
    errorDiv.classList.add("form-error")
    errorDiv.textContent = message
    ssMain.insertAdjacentElement("afterend", errorDiv)
  }

  #clearError(ssMain) {
    const errorDiv = ssMain.nextElementSibling
    if (errorDiv?.classList.contains("form-error")) {
      errorDiv.remove()
    }
  }
}
